export const LOGIN_REQUEST = "LOGIN_REQUEST"; 
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"; 
export const LOGIN_FAIL = "LOGIN_FAIL"; 

export const VERIFY_REGISTER_EMAIL_OTP_REQUEST = "VERIFY_REGISTER_EMAIL_OTP_REQUEST";
export const VERIFY_REGISTER_EMAIL_OTP_SUCCESS = "VERIFY_REGISTER_EMAIL_OTP_SUCCESS";
export const VERIFY_REGISTER_EMAIL_OTP_FAIL = "VERIFY_REGISTER_EMAIL_OTP_FAIL";

export const SEND_REGISTER_EMAIL_OTP_REQUEST = "SEND_REGISTER_EMAIL_OTP";
export const SEND_REGISTER_EMAIL_OTP_SUCCESS = "SEND_REGISTER_EMAIL_OTP_SUCCESS";
export const SEND_REGISTER_EMAIL_OTP_FAIL = "SEND_REGISTER_EMAIL_OTP_FAIL";


export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";